import type React from 'react';

export function useSwallowClick() {
  return (event: React.MouseEvent) => event.stopPropagation();
}
